export default __webpack_public_path__ + "static/media/cash-svgrepo-com.23d82221.svg";